@if (afasProjectId) {
    <div class="related-plannings">
        <div class="section-items" #sectionItems>
            @if (!beforeItems.length && !afterItems.length && !current && !loading) {
                <div class="empty">Geen andere planningen gevonden</div>
            }

            <div class="section-before">
                @for (planning of beforeItems; track planning.id) {
                    <app-need-item
                        [need]="planning"
                        [dateInsteadOfProjectId]="true"
                        [isCurrent]="false"
                        [readOnly]="true"
                        [materialsById]="materialsById"
                        (open)="open.emit(planning)" />
                }
            </div>

            @if (current) {
                <app-need-item
                    [need]="current"
                    [dateInsteadOfProjectId]="true"
                    [isCurrent]="true"
                    [readOnly]="true"
                    [materialsById]="materialsById"
                    (open)="open.emit(current)" />
            }

            <div class="section-after">
                @for (planning of afterItems; track planning.id) {
                    <app-need-item
                        [need]="planning"
                        [dateInsteadOfProjectId]="true"
                        [isCurrent]="false"
                        [readOnly]="true"
                        [materialsById]="materialsById"
                        (open)="open.emit(planning)" />
                }
            </div>
        </div>
    </div>
}
